import React from 'react';
import Styles from './Reservation.module.css';
import Hero from '../../pages/cars/carpages/HeroForm/Hero';
import { Helmet } from 'react-helmet';

function Reservation() {
  return (

    <div className={Styles.main_page}>
      <Helmet>
        <title>Reservation</title>
        
      </Helmet>

      <div className={Styles.first_pace}>

        <div className={Styles.hh}>

          <h1 >BOOK ONLINE FOR THE BEST RATE WITH AVIS</h1>
        </div>

        <Hero />

      </div>
      <div className={Styles.canti}>

      </div>
    </div>


  );
}

export default Reservation;
